import type { TaskStatus } from "@/sdk";

export default function contactStateTypeToTaskStatus(type: connect.ContactStateType): TaskStatus {
    switch (type) {
        case connect.ContactStateType.INIT:
        case connect.ContactStateType.INCOMING:
        case connect.ContactStateType.PENDING:
        case connect.ContactStateType.CONNECTING:
            return "pending";
        case connect.ContactStateType.CONNECTED:
        case connect.ContactStateType.PAUSED:
            return "assigned";
        case connect.ContactStateType.MISSED:
            return "missed";
        case connect.ContactStateType.REJECTED:
        case connect.ContactStateType.ERROR:
            return "cancelled";
        case connect.ContactStateType.ENDED:
            return "wrapping";
    }
}
